import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setStates: Function
  setAllStates: Function
  setCountries: Function
  setCurrentCountry: Function
  setValue: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getAll(apiUrls.states).then((data) => {
      props.setStates(data)
      props.setAllStates(data)
    })
    getAll(apiUrls.countries)
      .then((data) => props.setCountries(data))
      .then(() => {
        if (props.id !== undefined) {
          loadRecord(apiUrls.superadmins, props.id).then((data) => {
            props.reset(data)
            props.setCurrentCountry(data.country_id)

            props.setDataLoaded(true)
            props.setShowOverlay(false)
          })
        } else {
          //reset centers when customer changed
          props.setDataLoaded(true)
          props.setShowOverlay(false)
        }
      })
  }, [])
}

export default useInit
